var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs is-boxed"},[_c('ul',[_c('router-link',{attrs:{"to":{ name: 'client-bonuses-playthrough' },"active-class":"is-active","tag":"li"}},[_c('a',[_vm._v("Playthrough")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'client-bonuses-cashback' },"active-class":"is-active","tag":"li"}},[_c('a',[_vm._v("Cashback")])])],1)]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/bonuses/index.vue?vue&type=template&id=7bc89bec&scoped=true
// module id = qX4F
// module chunks = 0